export default __webpack_public_path__ + "static/media/STAFF.0efb1178.jpg";